export default __webpack_public_path__ + "static/media/web.3d7d416b.svg";